import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useT } from '../i18n';
import { useChatUI } from '../context/ChatUIContext';
import { useNotificationSystem } from '../context/NotificationContext';
import './MessagesButton.css';

// ── MESSAGES BUTTON ──────────────────────────────────────────────────────────
// The envelope in the site header — the one place both sides look for "has
// anyone written to me?". It sits beside the notification bell on every page
// that has a header, so Messages is reachable from anywhere rather than only
// from a designer's profile.
//
// Shown to EVERY signed-in account, unlike the bell: a customer receives
// replies just as a designer receives enquiries, so hiding it from one side
// would strand half of every conversation.
//
// THE COUNT IS LIVE, and it comes from NotificationProvider rather than from
// this component.
//
// It used to be a cached one-shot fetch per mount. That was cheap, but it only
// ever went UP: reading a conversation cleared the unread flag in Firestore and
// the badge carried on showing the old number until the cache expired or the
// page was reloaded. There is exactly one listener for the whole app, at the
// root, so subscribing here costs nothing extra — and the badge now drops the
// moment a thread is marked read.
export default function MessagesButton() {
  const { user } = useAuth();
  const { t } = useT();
  const { openMessages } = useChatUI();
  const { unreadTotal = 0 } = useNotificationSystem();
  const unread = unreadTotal;

  if (!user?.uid) return null;

  return (
    <button
      type="button"
      className="mb-btn"
      onClick={() => openMessages()}
      aria-label={t('chat_title')}
      title={t('chat_title')}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
      </svg>
      {unread > 0 && <span className="mb-badge">{unread > 9 ? '9+' : unread}</span>}
    </button>
  );
}
